import { render, staticRenderFns } from "./GatCompactField.vue?vue&type=template&id=ba06aea6&scoped=true"
import script from "./GatCompactField.vue?vue&type=script&lang=js"
export * from "./GatCompactField.vue?vue&type=script&lang=js"
import style0 from "./GatCompactField.vue?vue&type=style&index=0&id=ba06aea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba06aea6",
  null
  
)

export default component.exports